// Single source of truth for "which builder owns this workspace".
//
// Series workspaces (format 'tv_series') live at /series/:id and render
// SeriesBuilder. Every other workspace (feature, short, novel, tv_pilot,
// tv_episode) lives at /project/:id and renders ProjectWorkspace.
//
// Character creation, CreateProject's back button, and CharacterLevel's
// "Back to Workspace" all route through this so a character made inside the
// Series Builder returns to the Series Builder — not the film workspace.
export function workspaceRoute(id, format, tab) {
  const base = format === 'tv_series' ? `/series/${id}` : `/project/${id}`;
  return tab ? `${base}?tab=${tab}` : base;
}
